import { Block, component } from '../../../scripts/core/Component'

@component('navigation')
class Navigation extends Block {
  constructor (context) {
    super(context)

    this.navOpener = this.element('sandwich')

    this.navOpener.list.map((item) => {
      item.el.addEventListener('click', this.navOpenerClickHandler.bind(this))
    })

    this.isClosed = this.modifier('closed').isOn()
  }

  open() {
    this.modifier('closed').off()
    this.isClosed = false
  }

  close() {
    this.modifier('closed').on()
    this.isClosed = true
  }

  navOpenerClickHandler() {
    if(this.isClosed) {
      this.open()
    }
    else {
      this.close()
    }
  }
}

export {
  Navigation
}


// WEBPACK FOOTER //
// ./components/main/navigation/index.js